var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-bar",class:[`bg-${_vm.theme}`, {'active': _vm.visible}]},[_c('div',{staticClass:"text text-center",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }